/**
 * Alcedis form monolith
 *
 * @copyright   Alcedis GmbH
 * @version     SVN: $Id: jquery.form.js 208541 2021-11-12 08:52:54Z fsc $
 * @author      Gernot Kohlhaas <gko@alcedis.de>
 */

(function ($) {
    /**
     * alcedisForm
     *
     * @access  public
     * @param   object  options
     * @return  void
     */
    $.fn.alcedisForm = function (options) {
        /**
         * Global instance
         *
         * @access  private
         * @var     object
         */
        var self = this;

        /**
         * Global instance as jQuery Object
         *
         * @access  private
         * @var     jQuery
         */
        var $form = $(self);


        /**
         * Cached document selector
         *
         * @type {*|HTMLElement}
         */
        var $document = $(document);


        /**
         * i18n vars
         *
         * @access  private
         * @var     object
         */
        var i18n = pool.i18n.jquery_form_js;

        var displayCache = {
            elements: {},
            idents: {}
        };


        /**
         * helper method which find and caches form elements on display command handle
         *
         * @param   data.FQSelector string
         * @param   data.identifier string
         * @returns {Object}
         */
        var getDisplayCacheEntry = function (data) {
            var i, cacheIdent, identifierLength, $elements, $parentTablesWithoutFormTable;
            var selectorStack = [];
            var identifiers;

            // add fully qualified identifier to selector stack
            if (data.FQSelector !== undefined && data.FQSelector !== null && data.FQSelector.length > 0) {
                identifiers = data.FQSelector.split(",");
            } else {
                identifiers = data.identifier.split(",");
            }

            identifierLength = identifiers.length;

            while (identifierLength--) {
                selectorStack.push(".element." + identifiers[identifierLength]);
                selectorStack.push(".container_" + identifiers[identifierLength]);
                selectorStack.push(".wrap_" + identifiers[identifierLength]);
                selectorStack.push(':input[name="' + identifiers[identifierLength] +
                    '"]:not(.do_not_show)');
                selectorStack.push(':input[name^="' + identifiers[identifierLength] +
                    '_i18n"]:not(.do_not_show)');

                // active select
                selectorStack.push("table." + identifiers[identifierLength]);
            }

            // was element already detected? then return it directly
            for (i = (selectorStack.length - 1); i >= 0; i--) {
                if (displayCache.idents[selectorStack[i]] !== undefined) {
                    return displayCache.elements[displayCache.idents[selectorStack[i]]];
                }
            }

            cacheIdent = af.uniqueId();
            $elements  = $form.find(selectorStack.join(","));

            // create identification entries
            for (i = (selectorStack.length - 1); i >= 0; i--) {
                displayCache.idents[selectorStack[i]] = cacheIdent;
            }

            $parentTablesWithoutFormTable = $elements.parents("table");
            $parentTablesWithoutFormTable.pop();

            displayCache.elements[cacheIdent] = {
                "elements": $elements,
                "parentTrs": $elements.parents("tr"),
                "parentTablesWithoutFormTable": $parentTablesWithoutFormTable,
                "parentContainer": $elements.parents("div.block,div.slider-content,div.container"),
                "multi": $elements.parents("table.multi_column"),
                "inlineSeparator": $elements.prev("span.inline-element-separator")
            };

            // if $element is no form element and was not found via default selectors
            // try to get it directly via form find
            if ($elements.length === 0) {
                displayCache.elements[cacheIdent].elements = $form.find(identifiers.join(","));
            }

            return displayCache.elements[cacheIdent];
        };


        // Set default options
        options = $.extend({
            submitUrl: undefined,
            parent: undefined,
            redirect: true,
            children: false,
            language: pool.language,
            accessId: pool.accessId + '-' + pool.windowId,
            application: pool.application,
            controller: pool.controller,
            plugins: [],
            action: undefined,
            id: pool.id,
            i18n: pool.i18n,
            dateFormat: pool.dateFormat,
            params: pool.params,
            beforeSubmit: function () {},
            afterSubmit: function () {},
            success: function () {},
            harass: false,
            triggerHarass: true,
            stay: undefined
        }, options || {});


        /**
         * Initializes the form
         *
         * @access  public
         * @return  void
         */
        this.init = function () {
            var formElements = {};

            // Prevent double init() on form-tag
            if ($form.data('initialized') !== undefined && $form.data('initialized') === true) {
                console.warn('Form with id "' + self.attr('id') + '" is already initialized!');
                return false;
            }

            var entry = {
                name: self.attr('id'),
                form: self,
                i18n: i18n,
                children: options.children
            };

            alcedisEventHandler.instance.setRegister('alcedisForm', entry);
            alcedisEventHandler.instance.event('beforeFormOpen');

            if ($form.length > 1) {
                throw 'AlcedisForm can only handle one form at once.';
            }

            if ($form.length < 1 || $form.get(0).tagName === undefined || $form.get(0).tagName.toLowerCase() !== 'form') {
                throw "There's no form tag.";
            }

            $form.ajaxForm({
                beforeSubmit: function (fields, $form) {
                    self.submit({}, options.afterSubmit);
                    return false; // stop
                }
            });

            // TODO wrong method name
            options.beforeSubmit(self);
            options.plan = pool.plan[options.controller];

            $form.removeAttr('title');
            $form.pimpMyRadio();
            $form.fieldDatatypes();

            if ($.isFunction($form.addClearButton)) {
                $form.addClearButton();
            }

            $form.find('button').afButton();

            self.addAjaxValidations();
            self.addHarassingDialog();
            self.addAvoidDoubleClick();
            self.keyNavigation();

            if ($form.find(':input.activeselect').size()) {
                $form.find(':input.activeselect').activeSelect(self);
            }

            if (typeof $.codepicker === 'object') {
                $.codepicker.softReset();
            }

            // at first like this way - if more elements will need such functionality, please create extensible
            // object
            formElements["formWidgetSelect"] = $form.find("select");
            formElements["formWrapPicker"]   = $form.find("select.picker-element");

            // add select widget functionality to elements
            if (formElements["formWidgetSelect"].size() > 0) {
                formElements["formWidgetSelect"].afFormWidgetSelect();
            }

            // add picker functionality to elements
            if (formElements["formWrapPicker"].size() > 0) {
                formElements["formWrapPicker"].picker();
            }

            self.handleCommands(options.plan, { directly: true });

            if ($.browser.msie === true && $.browser.version <= 7) {
                $form.find('.buttons button').click(self.submit);
            }

            alcedisEventHandler.instance.event('afterFormOpen', { form: $form });

            // Set initialized flag to prevent double init() on form-tag
            $form.data('initialized', true);
        };


        /**
         * hold ajaxValidations when main submit is performed
         *
         * @access  public
         * @returns void
         */
        this.holdValidations = function () {
            // add a class on all validatable elements
            $form.addClass('hold_validation');
        };

        /**
         * set form
         *
         * @access  public
         * @param   object form
         * @returns void
         */
        this.setForm = function (form) {
            $form = form;
        };

        /**
         * The major problem is, that more then one ajax request can
         * loading simultanly. So, you need to find out, when the
         * first request starts and when the last request ends.
         *
         * Let's do this with a global queue stored in the body tag,
         * that will be increased and decreased respectively.
         *
         * @access  public
         * @return  void
         */
        this.addAvoidDoubleClick = function () {
            /**
             * Pointer to self (own object/function)
             *
             * @type {$.fn.alcedisForm}
             */
            var self = this;


            /**
             * Cached body-selector
             *
             * @type {*|HTMLElement}
             */
            var $body = $('body');


            /**
             * .ajaxStart and .ajaxComplete should only be attached once
             *
             * @type {boolean}
             */
            var handlersAttached = $body.data('handlersAttached') || false;


            /**
             * Show loading animation in each button and disable buttons.
             *
             * @access  public
             * @return  void
             */
            this.beforeSend = function () {
                // don't use $('button.button', $form);
                // $form will be overwritten by ajaxSetup in subform (i think ..)
                var $buttons = $('button.button, td.rec a');
                var replaceImages = pool.replaceLoadingImages !== false;

                $buttons
                    .not('.do_not_animate')
                    .enable(false) // disable button
                    .addClass('disabled')
                    .each(function () {
                        // replace button icon with loading image
                        if (replaceImages === true) {
                            var $image = $(this).find('img');

                            if ($image.length > 0) {
                                $image.each(function () {
                                    var $this = $(this);

                                    $this
                                        .data('old_image', $this.attr('src')) // backup original source
                                        .attr('src', pool.afPath + 'media/img/loading/small/white/transparent.gif')
                                        .addClass('revert_image') // add class for faster refind
                                    ;
                                });
                            }
                        }
                    })
                ;

                $body.data('ajax_queue', 1);
            };


            /**
             * Hide all loading animation and enable buttons again.
             *
             * @access  public
             * @return  void
             */
            this.complete = function () {
                // don't use $('button.button', $form);
                // $form will be overwritten by ajaxSetup in subform (i think ..)
                var $buttons = $('button.button, td.rec a');

                $buttons.find('img.revert_image')
                    .each(function () {
                        var $self = $(this);
                        $self.attr('src', $self.data('old_image'));
                    })
                    .removeClass('revert_image')
                ;

                $buttons.enable().removeClass('disabled');

                $body.data('ajax_queue', 0);
            };

            // Only attach .ajaxStart and .ajaxStop once
            if (handlersAttached === false) {
                $document.ajaxStart(self.beforeSend);

                // If you don't want buttons to be enabled again after ajax request, use $document.unbind('ajaxStop')
                $document.ajaxStop(self.complete);

                handlersAttached = true;
                $body.data('handlersAttached', handlersAttached);
            }
        };

        /**
         * Injects events for ajax validations
         *
         * @access  public
         * @param   jQuery $destination
         * @return  void
         */
        this.addAjaxValidations = function ($destination) {
            $destination = $destination || $form;

            if ($destination.is('form') === true && $destination.hasClass('validateable') === false) {
               return false;
            }

            var
                delay = {},
                time  = 300, // msec

                // Delay Timer
                validate = function () {
                    var
                        field  = this,
                        $field = $(field),
                        name   = $field.attr('name')
                    ;

                    if (delay[name] !== undefined) {
                        window.clearInterval(delay[name]);
                    }

                    delay[name] = window.setTimeout(function () {
                        self.validateField.call($field);
                    }, time);
                }
            ;

            var setActiveElementToScreensaver = function() {
                if ($.afScreenSaver !== undefined) {
                    $.afScreenSaver.setActiveElement($(document.activeElement));
                }
            };

            var $inputFields = $destination
                .find('input[type=text], input[type=password], textarea, input[type=hidden], select')
                .not('.external')
                .change(validate)
                .focus(setActiveElementToScreensaver)
            ;

            if ($.afScreenSaver !== undefined) {
                $.afScreenSaver.setHoldValidationFields($inputFields);
            }

            $destination.find(':checkbox, :radio').not('.external').click(validate);
        };

        /**
         * Bereitet die Validierung für ein Feld vor.
         *
         * @access  private
         * @param   jQuery $field
         * @return  boolean
         */
        this.validateField = function (force, moreData, afterSubmit) {
            if ($.isFunction($form.addClearButton)) {
                $form.addClearButton();
            }

            // check if field is on hold -> single field needs
            // no validation when whole form is being submitted
            if ($form.hasClass('hold_validation') === true) {
                return false;
            }

            var name = $(this).getInternalFieldName();
            var params = {
                force: force,
                form: self,
                field: this,
                name: name,
                abort: false
            };

            alcedisEventHandler.instance.event('beforeFormValidate', params);

            if (params.abort === true) {
                return;
            }

            alcedisEventHandler.instance.event('beforeFormValidateSuccess', params);

            var
                $content = $('#content'),
                left     =
                    parseInt($content.offset().left) +
                    parseInt($content.width()) +
                    parseInt($content.css('padding-left')) +
                    parseInt($content.css('padding-right'))
            ;

            $content.append($('<div/>')
                .attr('id', 'loading_validate')
                .addClass('loading small white transparent lonely')
                .css({
                    position: 'absolute',
                    top: $(this).parent().offset().top,
                    left: left
                }));

            self.buildSubmitUrl('validate', name);
            self.submit(moreData, undefined, afterSubmit);

            alcedisEventHandler.instance.event('afterFormValidate', { form: self, field: this });
        };


        /**
         * Submits the form
         *
         * @access  public
         * @param   object      moreData
         * @param   function    callback
         * @param   function    afterSubmit
         * @return  boolean
         */
        this.submit = function (moreData, callback, afterSubmit) {
            var temporaryContainerForBufferData = {};

            $form.ajaxSubmit({
                'accept': 'application/json, text/javascript',
                'url': options.submitUrl,
                'beforeSubmit': function (data) {
                    self.getUnsetRadiosAndCheckboxes(data);

                    // remove do_not_send fields
                    for (i in data) {
                        if ($('input[name="' + data[i].name + '"]').hasClass('do_not_send') === true) {
                            delete(data[i]);
                        }
                    }

                    if (typeof(moreData) === 'object' && moreData.name !== undefined) {
                        data.push(moreData);
                    }

                    // set "stay after action" flag
                    if (options.stay === true) {
                        data.push({name: 'stay_after_action', value: true});
                    }

                    alcedisEventHandler.instance.fire('beforeFormSubmit', {
                        data: data,
                        ajaxSubmit: this,
                        options: options,
                        form: $form
                    });

                    // send buffered data for ukey validation on buffer action
                    if (options.action === 'buffer') {
                        data = alcedisPoslistHandler.instance.getBufferedPosData(
                            data,
                            options.parent.parents('.list').parent(),
                            'bufferdata',
                            options.parent.attr('id') // $form.attr('id').replace('form_', '')
                        );
                    }

                    // sync buffer on mainform change only
                    options.parent === undefined && afBuffer.sync(options.controller, data);
                    // afBuffer.include(options.controller, data);

                    temporaryContainerForBufferData = data;
                },
                'success': function (receivedData) {
                    $('#loading_validate').remove();

                    alcedisEventHandler.instance.fire('afterFormSubmitSuccess', {});

                    if (typeof(callback) === 'function' && callback(self, receivedData) === false) {
                        return false;
                    }

                    self.handleCommands(receivedData, {
                        temporaryContainerForBufferData: temporaryContainerForBufferData
                    });

                    if (typeof(afterSubmit) === 'function') {
                        afterSubmit(self);
                    }

                    $form.removeClass('hold_validation');

                    alcedisEventHandler.instance.fire('afterFormSubmit', {
                        receivedData: receivedData,
                        options: options,
                        ajaxSubmit: this,
                        form: $form,
                        self: self
                    });
                },
                'type': 'POST',
                'dataType': 'json'
            });

            return false;
        };

        /**
         * Add dialog before leaving the form to warn for data loss.
         *
         * This feature is only used in the main form. Not in the pos form.
         *
         * @access  public
         * @return  void
         */
        this.addHarassingDialog = function () {
            if (options.harass === false || $form.hasClass('validateable') === false) {
                return;
            }

            var avoid = function (event) {
                // to avoid topbar redirect call on harass dialog
                var $this = $(this);

                if ($this.hasClass('prevent_harass') === true) {
                    event.preventDefault();

                    return;
                }

                if (event.originalEvent !== undefined) {
                    window.stop();
                }
            };

            var addHarass = function (event) {
                if (options.triggerHarass === false) {
                    return;
                }

                var $this = $(this);

                if ($this.hasClass('prevent_harass') === true) {
                    event.preventDefault();

                    return;
                }

                // .not('.do_not_harass') seems to fail for live clicks
                if ($this.hasClass('do_not_harass') || $this.attr('href') === 'javascript:;') {
                    return;
                }

                // do not harass if button is in an active select dialog
                if ($this.is('button') && $this.closest('.active-select').length > 0) {
                    return;
                }

                // Firefox & Webkit:
                // Only trigger this event on the primary mouse button (aka left click)
                if (event.type !== 'change' && event.button !== 0) {
                    return true;
                }

                var onclick = $this.attr('onclick') || undefined;
                var events = $.data(this, 'events');

                if ($this.is('button') === false && onclick === undefined && events !== undefined) {
                    var isNotAnHarassMousedownEvent = (
                        event.which !== 2 &&
                        events.mousedown !== undefined &&
                        events.mousedown.filter(function(ev) {
                            return ev.namespace !== "harass"
                        }).length > 0
                    );

                    var isNotAnHarassChangeEvent = (
                        events.change !== undefined &&
                        events.change.filter(function(ev) {
                            return ev.namespace !== "harass"
                        }).length > 0
                    );

                    var isNotAnHarassClickEvent = (
                        events.click !== undefined &&
                        events.click.filter(function(ev) {
                            return ev.namespace !== "harass"
                        }).length > 0
                    );

                    switch (true) {
                        // do not use this when middle click is used
                        case isNotAnHarassMousedownEvent:
                            onclick = function () {
                                $this.mousedown();
                            };
                            break;
                        case isNotAnHarassChangeEvent:
                            onclick = function () {
                                $this.change();
                            };
                            break;
                        case isNotAnHarassClickEvent:
                            onclick = function () {
                                $this.click();
                            };
                            break;
                    }
                }

                if (onclick !== undefined){
                    window.stop();
                }

                var href     = this.href;
                var stay     = false;
                var $element = $(this);

                // Only check classes, when attr() method is even callable
                if (typeof $element.attr === 'function') {
                    var linkClasses = $(this).attr('class');

                    // Only check class of clicked element, when it actually has class attribute
                    if (typeof linkClasses !== 'undefined' && linkClasses !== null) {
                        stay = linkClasses.indexOf('AndStay') !== -1;
                    }
                }

                var doRedirect = function (href, onclick) {
                        $('form.harassable').removeClass('harassable');
                        if (typeof onclick === 'function') {
                            onclick();
                        } else if (onclick !== undefined){
                            eval(onclick);
                        }else if (href === undefined) {
                            self.buildSubmitUrl('cancel', undefined, stay);
                            self.submit();
                        } else {
                            self.handleCommands({'redirect': [href]});
                        }
                    }
                ;

                var $harassingDialogContent = $(
                    '<div class="harass-dialog">'
                        +     '<div class="question">'
                        +         i18n.harassing_dialog_question
                        +     '</div>'
                        +     '<div class="buttons center-buttons">'
                        +         '<button class="save">'    + i18n.harassing_dialog_btn_save    + '</button>'
                        +         '<button class="discard">' + i18n.harassing_dialog_btn_discard + '</button>'
                        +     '</div>'
                        + '</div>'
                );

                $harassingDialogContent.find('button.save').afButton().click(function () {
                    var redirect = $('img.error', $form).length === 0;

                    self.buildSubmitUrl(options.id == 0 ? 'insert' : 'update');
                    self.submit({}, function ($form, receivedData) {
                        if (receivedData.redirect === undefined) {
                            redirect = false;
                        } else if (href === undefined && onclick === undefined) {
                            href = receivedData.redirect.pop();
                        }

                        if (redirect === true) {
                            options.triggerHarass = false;
                            doRedirect(href, onclick);
                            return false;
                        } else {
                            $harassingDialogContent.dialog('close');
                            return true;
                        }
                    });
                });

                $harassingDialogContent.find('button.discard').afButton().click(function () {
                    options.triggerHarass = false;
                    doRedirect(href, onclick);
                });

                $harassingDialogContent.dialog({
                    title: i18n.harassing_dialog_title,
                    width: 420,
                    minHeight: 50,
                    modal: true
                });

                return false;
            };

            var harassingDialog = function () {
                $form.addClass('harassable');

                var $navToggleElements = $("a").filter(function() { return !this.attributes['href']; });
                var $elements = $([
                    'a[target=_self]',
                    'div.access_container table.access',
                    'a[target=]:not(.ui-state-default, .ui-corner-all, #ui-active-menuitem, .nipple, .searchlist, .load, .lock)',
                    'button.cancel',
                    '#language',
                    'div.list.no_js button[onclick*="window.location"]'
                ].join(',')
                ).not($navToggleElements);

                $elements.unbind('mousedown.harass').bind('mousedown.harass', avoid);
                $elements.unbind('click.harass').bind('click.harass', addHarass);
                $elements.unbind('change.harass').bind('change.harass', addHarass);

                $form.find(':input').unbind('change', harassingDialog); // delete event function

                return 'once';
            };

            $form.find(':input').bind('change', harassingDialog); // add event function once

            alcedisEventHandler.instance.addEvents({ 'afterPosListUpdate': harassingDialog });
            alcedisEventHandler.instance.addEvents({ 'afterActiveSelectUpdate': harassingDialog });
        };


        /**
         * completely disable redirect on form
         */
        this.forceRedirectDisable = function () {
            options.redirect = false;
        };

        /**
         * Builds the submit url
         *
         * @access  public
         * @param   {String} action
         * @param   {String} args
         * @return  {String}
         */
        this.buildSubmitUrl = function (action, args, stay) {
            options.action = action;

            if (action === 'validate' || action === 'download') {
                var params = [
                    options.language,
                    options.accessId,
                    options.application,
                    options.controller,
                    action
                ];

                if (args !== undefined) {
                    params.push(args);
                }

                params.push(options.id);
                params.push(options.params.join('/'));
            } else if (args !== undefined) {
                var params = [
                    options.language,
                    options.accessId,
                    options.application,
                    options.controller,
                    action,
                    options.id
                ];

                if (typeof args === 'string') {
                    params.push(args);
                } else {
                    params.concat(args);
                }
            } else {
                var params = [
                    options.language,
                    options.accessId,
                    options.application,
                    options.controller,
                    action,
                    options.id,
                    options.params.join('/')
                ];
            }

            options.submitUrl = $('base').attr('href') + params.join('/').replace(/\/\//g, '/');
            options.stay = stay;

            return self;
        };

        /**
         * Handle the received Data
         *
         * @param   {object} response
         * @param   {object} settings
         */
        this.handleCommands = function (response, settings) {
            settings = settings || {};

            outer:for (var command in response) {
                switch (command) {
                    case 'buffer':
                        alcedisEventHandler.instance.fire('commandBuffer', {
                            response: response,
                            settings: settings,
                            handleCommands: this
                        });

                        break;

                    case 'message':
                        self.handleMessages(response[command]);
                        break;

                    case 'element':
                        self.displayElement(response[command], settings);
                        break;

                    case 'redirect':
                        options.success();

                        var url = response[command].pop(); // last from stack

                        if (options.redirect === false)
                            break;

                        // Buttons should not be enabled again on redirect!
                        $document.unbind('ajaxStop');

                        if (af.isEmpty(url)) {
                            window.history.back();
                        } else {
                            window.location.href = url;
                        }

                        break outer;

                    case 'value':
                        var valueCache = {};

                        $.each(response[command], function (key, current) {
                            var
                                field              = current.field,
                                value              = current.value,
                                preAllocationValue = current.preAllocationValue;
                                fieldSelectors     = [],
                                elementSelector    = current.elementSelector,
                                $elements          = $(), // empty jquery object stack
                                showEffect         = current.showEffect || 'fadeIn',
                                showSpeed          = current.showSpeed  || 'slow',
                                hideEffect         = current.hideEffect || 'fadeOut',
                                hideSpeed          = current.hideSpeed  || 'fast'
                            ;

                            // the pre allocation value will be used in case value is null
                            if (value === null) {
                                value = preAllocationValue;
                            }

                            // hard fallback if someone doesn't uses core response value command
                            if (current.hasOwnProperty('fieldSelector') === false) {
                                fieldSelectors = [
                                    '.container_' + field + ' .displayOnlyInput :input[name="' + field + '"]:not(.alreadyPreAllocated)',
                                    '.container_' + field + ' :input[name="' + field + '"]:not(.do_not_change_value):not(.alreadyPreAllocated)'
                                ];
                            } else {
                                // split field selector for compatibility
                                fieldSelectors = current.fieldSelector.split(',');
                            }

                            // hard fallback if someone doesn't uses core response value command
                            if (current.hasOwnProperty('elementSelector') === false) {
                                elementSelector = '.container_' + field + ' .value';
                            }

                            // only process if element selector has a length
                            if (elementSelector.length > 0) {
                                $elements = $form.find(elementSelector);
                            }

                            // In case more than one "value" command is received for the same field: Check, if target
                            // value was already set
                            if (valueCache[field] !== value) {
                                // Fake element to "normalize" html for comparison (e.g. <br> vs. <br/>)
                                var $fakeElement   = $('<div/>');
                                valueCache[field] = value;

                                $elements.each(function () {
                                    var $element       = $(this);
                                    var old            = $element.html();
                                    // "Normalize" value (see comment for $fakeElement)
                                    var sanitizedValue = $fakeElement.html(value).html();

                                    // Do not replace value again, if new value already matches old value
                                    if (old != sanitizedValue) {
                                        $element[hideEffect](hideSpeed, function() {
                                            $element.html(value)[showEffect](showSpeed);
                                        });
                                    }
                                });
                            }

                            // Find input elements which can be changed (not readonly)
                            $.each(fieldSelectors, function (key, selector) {
                                var $input;

                                // only process if selector has a length
                                if (selector.length > 0) {
                                    $input = $form.find(selector);

                                    // mark inputs as preallocated
                                    if (preAllocationValue !== null) {
                                        $input.addClass('alreadyPreAllocated');
                                    }

                                    // Only take action if at least one field was found and
                                    // do not change value and re-validate, if new value is the same as old value
                                    if (
                                        $input.length > 0 &&
                                        // Cast to String value because "" and 0 comparison is falsy
                                        String($input.attr('value')) !== String(value)
                                    ) {
                                        $input.val(value); // Set new value
                                        $input.trigger('change'); // Trigger validation of field
                                    }
                                }
                            });
                        });

                        break;

                    case 'json':
                        if (typeof(settings) === 'function') {
                            settings(response[command]);
                        }
                        break;

                    case 'eval':
                        for (var i in response[command]) {
                            try {
                                eval(response[command][i]);
                            } catch (e) {
                                console.error(e);
                            }
                        }
                        break;

                    case 'html':
                        for (var i in response[command]) {

                            var
                                html     = response[command][i].html,
                                selector = response[command][i].selector
                            ;
                            if (response[command][i].validateForm === true) {
                                var $html = $(html).not('script');

                                $form.find(selector).replaceWith($html);

                                $(html).filter('script').each(function () {
                                    $.globalEval(this.text);
                                });

                                self.addAjaxValidations($html);
                            } else {
                                $(selector).replaceWith(html);
                            }
                            $(html).fieldDatatypes();
                        }

                        break;

                    default:
                        throw 'Unknown command "' + command + '".';
                        break;
                }
            }
        };

        /**
         * handle messages (show / hide)
         *
         * @param   {Array} data
         * @return  void
         */
        this.handleMessages = function (data) {
            // TODO initiate once

            $.jGrowl.defaults.closerTemplate = '<div>' + i18n.messages_close + '</div>';
            $.jGrowl.defaults.speed = '0';

            for (var i in data) {
                var message = data[i];

                if (message.visibility === false) {
                    $('.container_' + message.field + ' img.valid').remove();
                    $('#jGrowl .' + message.field).remove();

                    continue;
                }

                message.text += '&nbsp;'; // opacity workaround

                self.addMessage(message);

                if (message.autoGrowl === true) {
                    self.addGrowl(message);
                }
            }
        };


        /**
         * show or hide elements
         *
         * @param   {Array} data
         * @param   {object} settings
         */
        this.displayElement = function (data, settings) {
            var i, it, name, directly, $element, $elements, cacheEntry;

            // TODO refactor selectors to form elements (GUI 2.0)
            var $parentTablesWithoutFormTable, $parentTrs, $parentContainer, $multi;
            var check, checks = {
                trs: [], // first check trs
                tables: [] // then tables
            };
            var checkUID = af.uniqueId();

            // list of element selectors which prevents auto hide
            var autoHidePrevention = [
                ':input[type!=hidden]:not(.hidden, button):not(.do_not_show):visible', // visible input elements
                'span.value:not(.hidden):visible', // visible value label
                '.do_not_hide', // force do not hide
                'button:visible', // all visible buttons
                'span.picker-element:visible', // visible picker elements
                'tr:visible :input.hidden.activeselect', // visible active selects
                '.sdv-mark'
            ].join(',');

            /**
             * Actually triggers show or hide
             *
             * @param   {jQuery}  $element
             * @param   {boolean} visibility
             * @param   {boolean} directly
             */
            var visibility = function ($element, visibility, directly) {
                // temporarily disabled due to jquery changes in fader-animation
                if (true || directly === true) {
                    visibility
                        ? $element.show()
                        : $element.hide();
                } else {
                    visibility
                        ? ($element.is(':hidden')  ? $element.fadeIn().show() : false)  /* fix ie8 additional show() */
                        : ($element.is(':visible') ? $element.fadeOut() : null);
                }
            };

            /**
             * bookmark elements depth in DOM for correct checking of visibility
             */
            var bookmarkElementChecks = function ($elements, target) {
                var depth = $elements.length - 1;

                $elements.each(function () {
                    // create depth entries
                    if (target[depth] === undefined) {
                        target[depth] = [];
                    }

                    target[depth].push($(this));
                    depth--;
                });

                return target;
            };

            for (i in data) {
                name = data[i].identifier;

                // check identifier plausibility (must be string and filled)
                if (typeof name !== "string" || name.length === 0) {
                    continue;
                }

                directly   = settings.directly || data[i].directly || false;
                cacheEntry = getDisplayCacheEntry(data[i]);

                // get cache entry elements
                $elements                     = cacheEntry.elements;
                $parentContainer              = cacheEntry.parentContainer;
                $multi                        = cacheEntry.multi;
                $parentTablesWithoutFormTable = cacheEntry.parentTablesWithoutFormTable;
                $parentTrs                    = cacheEntry.parentTrs;

                // execute "show" commands on all elements
                if (data[i].visibility === true) {
                    visibility($parentContainer,                true, directly);
                    visibility($parentTablesWithoutFormTable,   true, directly);
                    visibility($parentTrs,                      true, directly);
                    visibility($elements.removeClass('hidden'), true, directly);
                    visibility(cacheEntry.inlineSeparator,      true, directly);

                    // flag as already checked (with uid)! these elements will definitely be shown
                    $parentTrs.data('displayCheck', checkUID);
                    $parentTablesWithoutFormTable.data('displayCheck', checkUID);
                } else {
                    // hide target element
                    visibility($elements.addClass('hidden'), false, directly);

                    // needed for correct read only view. add hidden class on value span to be able
                    // to detect tr's which should not get hidden.
                    $elements.find('span.value').addClass('hidden');

                    // hide "prepending" inline separator
                    if (cacheEntry.inlineSeparator.length > 0) {
                        visibility(cacheEntry.inlineSeparator, false, directly);
                    }

                    // Hide whole multi column wrap, when in inline wrap (?)
                    if ($multi.size() && $multi.parent().hasClass('inline')) {
                        visibility($multi, false, directly);
                    }

                    // hide parent containers (if no elements which could preventing this found)
                    if ($parentContainer.find(autoHidePrevention).length === 0) {
                        visibility($parentContainer, false, directly);
                    }

                    checks.tables = bookmarkElementChecks($parentTablesWithoutFormTable, checks.tables);
                    checks.trs    = bookmarkElementChecks($parentTrs, checks.trs);
                }
            }

            // execute hide checks on each bookmarked element
            for (check in checks) {
                for (i = checks[check].length; i >= 0; i--) {
                    // only check tables for depths which exist
                    if (checks[check][i] !== undefined) {
                        // check all tables for depth
                        for (it = (checks[check][i].length - 1); it >= 0; it--) {
                            $element = checks[check][i][it];

                            // check each element only once
                            if ($element.data('displayCheck') !== checkUID) {
                                // mark as already checked
                                $element.data('displayCheck', checkUID);

                                // hide element if no auto hide prevention element was found
                                if ($element.find(autoHidePrevention).length === 0) {
                                    visibility($element, false, true);
                                } else {
                                    //DEBUG
                                    // console.log('Auto Hide prevention caused by:');
                                    // console.info($element.find(autoHidePrevention));
                                }
                            }
                        }
                    }
                }
            }
        };


        /**
         * show a message
         *
         * @param   {object} message
         */
        this.addMessage = function (message) {
            if (message.field === null) {
                return;
            }

            var $img = $form.find('img.valid.' + message.type + '.' + message.field),
                addMessage = function () {
                    self.addGrowl(message, true);
                }
            ;

            if ($img.length > 0) {
                $img.click(addMessage);
            } else {
                // match our selector for pos table rows, example: posForm~id_12:dyn_id_23
                // where id is the id from record if exists, and dyn:id is java script side uid
                // this selector was generated in getPosSelector method of afRecord
                var posFormSelectorParts = message.field.match(/([^~]*)~([^:]*):(.+)/);

                $img = $('<img class="valid ' + message.id + ' ' + message.type + ' ' + message.field +
                    '" src="' + pool.afPath + 'media/img/action/rec/validator/' + message.type + '.gif" alt=""/>')
                    .click(addMessage)
                ;

                if (posFormSelectorParts !== null) {
                    // if we have this complex selector for posForm rows
                    var posFormSelector = posFormSelectorParts[1];
                    var idSelector = posFormSelectorParts[3] !== '_'
                        ? posFormSelector + ' tr.' + posFormSelectorParts[3]+ ' td.validationmarker'
                        : null
                    ;
                    var ukeySelector = posFormSelectorParts[2] !== '_'
                        ? posFormSelector + ' tr.' + posFormSelectorParts[2]+ ' td.validationmarker'
                        : null
                    ;
                    var $posField = idSelector !== null ? $form.find(idSelector) : $form.find(ukeySelector);

                    var children =  $posField.children();
                    $posField.append($img, children);
                } else {
                    // standard selector: field
                    var $container = $form.find('.element.container_' + message.field).not('tr').not('.inline_label');

                    if ($container.hasClass('postable')) {
                        $container.find('.bar').prepend($img)
                    }
                    else {
                        $container.append($img);
                    }
                }
            }
        };


        /**
         * show growl
         *
         * @param   {object} message
         * @param   {object} effect
         * @param   {object} func
         * @param   {boolean} effect
         */
        this.addGrowl = function (message, effect, func) {
            // hack to unique jgrowl messages
            for (var i in $.fn.jGrowl.prototype.notifications) {
                if ($.fn.jGrowl.prototype.notifications[i].options.id === message.id) {
                    return false;
                }
            }

            var $jGrowlMessage = $('#jGrowl .' + message.id);

            if ($jGrowlMessage.length === 0) {
                if (message.closeTemplate === false) {
                    message.closeTemplate = ' ';
                } else {
                    message.closeTemplate =  '&times;';
                }

                $.jGrowl(message.text, {
                    id: message.id,
                    life: message.text.length * 50, // time of visibility deppends on message text length
                    theme: message.type + ' ' + message.id + ' ' + message.field,
                    sticky: message.sticky || false,
                    open: func,
                    closer: message.closer || true,
                    closeTemplate: message.closeTemplate
                });
            } else {
                // shake effect .. jquery ui is not so good
                if (effect === true) {
                    var
                        time = 80, // ms
                        destination = 3 // px
                    ;

                    $jGrowlMessage.css('position', 'relative');

                    for (var i = 0; i < 4; ++i) {
                        $jGrowlMessage
                            .animate({ top: destination      }, time, 'swing')
                            .animate({ top: destination * -1 }, time, 'swing');
                    }

                    $jGrowlMessage.animate({top: 0}, time, 'swing', function () {
                        $jGrowlMessage.css('position', 'static');
                    });
                }

                $jGrowlMessage.data('jGrowl').created = new Date(); // refresh time of message
            }
        };

        /**
         * removes all open growl messages
         */
        this.removeAllGrowls = function () {
            $('#jGrowl .jGrowl-notification').hide();
        };

        /**
         * Legt die nicht gesetzten Radiobuttons und Checkboxen in ein Array.
         *
         * @access  public
         * @param   {Array} data (reference!!!)
         * @return  array
         */
        this.getUnsetRadiosAndCheckboxes = function (data) {
            var
                radiosAndCheckboxes = {},
                unset = []
            ;

            $form.find(':radio, :checkbox').each(function () {
                if (radiosAndCheckboxes[this.name] === false || radiosAndCheckboxes[this.name] === undefined) {
                    radiosAndCheckboxes[this.name] = this.checked;
                }
            });

            for (var key in radiosAndCheckboxes) {
                if (radiosAndCheckboxes[key] === false) {
                    data.push({name: key, value: ''});
                    unset.push({name: key, value: ''});
                }
            }

            return unset;
        };

        /**
         * @access  public
         * @return  jQuery
         */
        this.getOptions = function () {
            return options;
        };

        /**
         * @access  public
         * @param   name
         * @param   value
         * @return  jQuery
         */
        this.setOptions = function (name, value) {
            options[name] = value;

            return this;
        };

        this.getPlugin = function (pluginName) {
            var pl = null;

            $.each(options.plugins, function (i, plugin) {
                if (plugin.name === pluginName) {
                    pl = plugin.plugin;

                    return false;
                }
            });

            return pl;
        };


        /**
         * plugins for later calling
         * add plugin to option.plugins if not exist, else do nothin, cause reference
         *
         * @param name
         * @param $plugin
         */
        this.setPlugin = function (name, $plugin) {
            var pluginExists = false;

            for (var currentPlugin in options.plugins) {
                if (currentPlugin.name === name) {
                    pluginExists = true;
                    break;
                }
            }

            if (pluginExists === false) {
                options.plugins.push({ 'name': name, 'plugin': $plugin });
            }

            return this;
        };

        return this;
    };


    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // PLUGINS
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * $('[name=birthdate]', $form).setFieldValue(value, effect);
     *
     * @param value
     * @param effect
     * @param validate
     */
    $.fn.setFieldValue = function (value, effect, validate) {
        if (typeof(effect) === 'function') {
            effect($(this));
        }

        return this.each(function () {
            var
                field   = this,
                $field  = $(field),
                tagname = field.tagName.toLowerCase(),
                type    = field.type
            ;

            // if element has custom set field value function
            if (typeof $field.data("$.setFieldValue") === "function") {
                $field.data("$.setFieldValue")($field, value);
            } else {
                if (value === null) {
                    value = '';
                }

                switch (tagname) {
                    case 'input':
                        switch (type) {
                            case 'text':
                            case 'hidden':
                                field.value = value;
                                break;

                            case 'radio':
                                field.checked = (field.value === value);
                                break;

                            case 'checkbox':
                                field.checked = (value === '1');
                                break;
                        }
                        break;

                    case 'textarea':
                        field.value = value;
                        break;

                    case 'select':
                        for (var i = 0; i < field.options.length; ++i) {
                            field.options[i].selected = false;

                            if (field.options[i].value === value) {
                                field.options[i].selected = true;
                            }
                        }
                        break;
                }
            }

            if (validate !== false) {
                if (type === 'text' || type === 'password' || tagname === 'textarea') {
                    $field.trigger('blur').trigger('change');
                } else if (type === 'hidden' || tagname === 'select') {
                    $field.trigger('change');
                } else if (type === 'radio' || type === 'checkbox') {
                    $field.trigger('change');
                }
            }
        });
    };


    /**
     * get the internal field name, thanks to i18n
     *
     * @access  public
     * @return  string
     */
    $.fn.getInternalFieldName = function () {
        var
            $field = $(this),
            name   = $field.attr('name')
        ;

        switch (true) {
            case $field.hasClass('phone'):    name = name.replace('_i18n', '');  break;
            case $field.hasClass('date'):     name = name.replace('_i18n', '');  break;
            case $field.hasClass('float'):    name = name.replace('_i18n', '');  break;
            case $field.hasClass('fake'):     name = name.replace('_i18n', '');  break;
            case $field.hasClass('password'): name = name.replace(/_pwd_\w+/, ''); break;
        }

        return name;
    };


    /**
     * @access  public
     * @return  string
     */
    $.fn.getInternalFieldValue = function () {
        var
            $field = $(this),
            name   = $field.getInternalFieldName(),
            value  = null
        ;

        if (name === this.name) {
            value = $(this).fieldValue()[0];
        } else {
            var $container = $field.parents('[class*=container_]').get(0);

            value = $container.find('[name="' + name +'"]').fieldValue()[0];
        }

        return value;
    };


    /**
     * Get the label (i18n) for the field value
     *
     * @access  public
     * @param   {boolean} withPending
     * @return  string
     */
    $.fn.getFieldI18nValue = function(withPending) {
        withPending = withPending === undefined ? false : withPending;

        var
            $field      = $(this),
            $form       = $field.closest('form'),
            tagname     = $field.get(0) === undefined ? '' : $field.get(0).tagName.toLowerCase(),
            fieldname   = $field.attr('name'),
            i18nValue   = '',
            value       = $field.fieldValue()[0]
        ;

        var createPending = function($field, noValue, blank, value) {
            if (withPending === true) {
                var container  = $field.closest('.container');
                var appending  = container.find('span.appending').text();
                var prepending = container.find('span.prepending').text();
                if (noValue === true && value.length === 0) {
                    value = pool.i18n.common.no_value;
                }
                value = prepending + '&nbsp;' + value + '&nbsp;' + appending;
            }
            return value;
        };

        switch (tagname) {
            case 'input':
                if ($field.attr('size') === '27') {
                    i18nValue = $field.next('span').html();
                    i18nValue = createPending($field, true, '&nbsp;', i18nValue);
                } else if ($field.hasClass('internal')) {
                    i18nValue = $form.find('[name="' + fieldname + '_i18n"]').val();
                    i18nValue = createPending($field, false, '&nbsp;', i18nValue);
                } else if ($field.attr('type') === 'checkbox') {
                    if ($field.hasClass('multipicker-element-selected')) {
                        // workaround for disabled checkboxes, the value would not be filled with fieldValue
                        value = '1';
                    }
                    if (withPending === true) {
                        i18nValue = value !== undefined ? pool.i18n.common.check : '';
                    } else {
                        var checkboxLabel = $.trim($field.closest('label').text());

                        // Use default "checked" uft8 icon/text, when checkbox has no label
                        if (checkboxLabel.length === 0) {
                            checkboxLabel = pool.i18n.common.check;
                        }

                        i18nValue = value !== undefined ? checkboxLabel : '';
                    }

                    i18nValue = createPending($field, true, '&nbsp;', i18nValue);
                } else if ($field.attr('type') === 'radio') {
                    i18nValue = $field.filter(':checked').closest('label').text();
                    i18nValue = createPending($field, true, '&nbsp;', i18nValue);
                } else if ($field.attr('type') === 'hidden') {
                    var $parent = $field.parent();

                    // Determine, if raw value from hidden field or text of parent is to be used for pos list column.
                    // Needed for example by the phone wrap where the hidden field is the correct field an the parent
                    // is a span.container.
                    if ($parent.hasClass('pos-raw-value') === true || $field.hasClass('pos-raw-value') === true) {
                        i18nValue = value;
                    } else {
                        i18nValue = $parent.text();
                    }

                    i18nValue = createPending($field, false, '', i18nValue);
                } else {
                    i18nValue = value;
                    i18nValue = createPending($field, false, '', i18nValue);
                }
                break;

            case 'textarea':
                i18nValue = value;
                i18nValue = createPending($field, false, '&nbsp;', i18nValue);
                break;
            case 'span':
                // solution for query plugin, to handel readOnly checkboxes, maybe this should all be done in another
                // way - "afSpec" & "getFieldI18nValue" should act the same way, at the moment they don't
                value = $($field).find('strong').attr('title');
                if (value.length > 0) {
                    i18nValue = pool.i18n.common.check;
                }
                i18nValue = createPending($field, true, '&nbsp;', i18nValue);
                break;
            case 'select':
                i18nValue = $form.find('[name="' + fieldname + '"] option[value=' + value + ']').text();
                i18nValue = createPending($field, true, '&nbsp;', i18nValue);
                break;
        }

        return $.trim(i18nValue);
    };



    /**
     * Man kann die RadioButtons wieder deselektieren.
     *
     * @access  public
     * @param   {jQuery} $dom
     * @return  void
     */
    $.fn.pimpMyRadio = function () {
        return $(this).find(':radio').each(function () {
                var
                    $radio  = $(this),
                    $parent = $radio.parent(),
                    doChange = function () {
                        $radio.data('checked', $radio.prop('checked'));
                    }
                ;

                if ($parent.is('label') === true) {
                    $parent
                        .mouseup(doChange)
                        .keyup(function (event) {
                            if ((event.which || event.charCode) === 32) { // if space pressed
                                doChange();
                            }
                        });
                }
            })
            .mouseup(function () {
                var $radio = $(this);

                if ($radio.prop('readonly') === false) {
                    $radio.data('checked', $radio.prop('checked'));
                }
            })
            .click(function () {
                var $radio = $(this);

                if ($radio.prop('readonly') === false) {
                    if ($radio.data('checked') !== false) {
                        $radio
                            .prop('checked', false)
                            .data('checked', false)
                            .trigger('change');
                    }
                }
            });
    };


    /**
     * add key navigation to form for save-, cancel-action etc.
     *
     * @access  public
     * @param   (jQuery) $dom
     * @return  void
     */
    $.fn.keyNavigation = function () {
        var self = this;
        $('html').unbind('keydown').keydown(function (event) {
            var $form            = $(self);
            var overlayActive    = $('.ui-widget-overlay').length > 0;
            var topBarExpanded   = $('div#topbar div.status').hasClass('expand');
            var $posForm         = $('.ui-dialog:visible form');
            var posFormOpenend   = $posForm.length > 0;
            var $dialog          = $posForm.closest('.ui-dialog:visible');
            var $harassingDialog = $('div.harass-dialog:visible');

            // detect if pos form has highest z index
            $form.find('.ui-dialog:visible').each(function () {
                var $currentElement = $(this);
                if ($currentElement !== $dialog && $currentElement.zIndex() > $dialog.zIndex()) {
                    posFormOpenend = false;
                }
            });

            if (overlayActive === false && topBarExpanded === false || posFormOpenend === true ||
                $harassingDialog.length > 0)
            {
                var pressedKey = event.which || event.keyCode;

                if (posFormOpenend === true) {
                    posFormKeyNavigation(event, pressedKey, $dialog);
                } else {
                    mainFormKeyNavigation(event, pressedKey);
                }

                // form key navigation
                switch (pressedKey) {
                    case af.navigationKeyMapping.f1:
                        openKeyNavigationHelpDialog($form);
                        event.preventDefault();
                        break;
                    case af.navigationKeyMapping.right:
                    case af.navigationKeyMapping.left:
                        var $focusedButton = $harassingDialog.find('button:focus');
                        $focusedButton.parent().find('button:not(:focus)').addClass('focus').focus();
                        $focusedButton.removeClass('focus').blur();
                        break;
                    default:
                        break;
                }
            }

            return true;
        });

        /**
         * add key navigation in pos form
         *
         * @param event
         * @param pressedKey
         * @param $dialog
         * @returns {boolean}
         */
        var posFormKeyNavigation = function (event, pressedKey, $dialog) {
            switch (pressedKey) {
                case af.navigationKeyMapping.s:
                    if (event.ctrlKey === true) {
                        $dialog.find('td.element.buttons button.insert').click();
                        $dialog.find('td.element.buttons button.update').click();
                        event.preventDefault();
                    }
                    break;
                default:
                    break;
            }

            return true;
        };


        /**
         * add key navigation in main form
         *
         * @param event
         * @param pressedKey
         * @param $form
         * @param self
         * @returns {boolean}
         */
        var mainFormKeyNavigation = function (event, pressedKey) {
            $form = $('form.validateable');
            switch (pressedKey) {
                case af.navigationKeyMapping.s:
                    if (event.ctrlKey === true) {
                        $form.find('td.element.buttons button.insert').click();
                        $form.find('td.element.buttons button.update').click();
                        event.preventDefault();
                    }
                    if (event.altKey === true) {
                        var $sidebar = $('div#sidebar');
                        if ($sidebar.length > 0) {
                            $('html').unbind('keydown');
                            $sidebar.find('a.nipple').click(); // toggle sidebar
                            event.preventDefault();
                        }
                    }
                    break;
                case af.navigationKeyMapping.t:
                    if (event.altKey === true) {
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        $('div#topbar div.left').click();
                    }
                    break;
                default:
                    break;
            }

            return true;
        };

        /**
         * open key navigation help dialog and bind keydown event for closing with esc
         *
         * @param $form
         */
        var openKeyNavigationHelpDialog = function ($form) {
            var i18n = pool.i18n.jquery_form_js;

            var $keymapDialog = $('<div/>')
                .addClass('harass-dialog')
                .append($('<div/>').addClass('keymap')
                    .append($('<table/>').addClass('keymap'))
                )
            ;

            var keymap = i18n.keymap_keymap.split('<br/>');

            var content = '';
            $.each(keymap, function(key, line) {
                var currentRow = line.split(':');
                if (currentRow.length === 1) {
                    content += '<tr style="font-weight: bold"><td>' + $.trim(currentRow[0]) + '</td></tr>';
                } else {
                    content +=  '<tr><td width="30%">' + $.trim(currentRow[0]) + '</td>' +
                        '<td>'+ $.trim(currentRow[1]) +'</td></tr>'
                    ;
                }
            });

            $keymapDialog.find('table.keymap').append(content);

            var $dialog = $('<div/>').addClass('key-navigation-help-dialog').append($keymapDialog).dialog({
                title      : i18n.keymap_title,
                resizable  : false,
                modal      : true,
                autoOpen   : true,
                width      : 600,
                position   : ['center', 200],
                maxHeight  : $(window).height() - 50,
                close      : function () { $(this).dialog('destroy').remove(); }
            });

            $('html').unbind('keydown').keydown(function (event) {
                if (event.keyCode === af.navigationKeyMapping.esc || event.keyCode === af.navigationKeyMapping.f1) {
                    $form.keyNavigation();
                    $dialog.dialog('close');
                }
            });
        };
    };


    /**
     * Discard invalid chars in text fields
     *
     * @access  public
     * @return  {jQuery}
     */
    $.fn.fieldDatatypes = function () {

        /**
         * $inputFields
         *
         * @type {jQuery}
         */
        var $inputFields = $(this).find('input');


        /**
         * element filter types
         *
         * @type {}
         */
        var elementTypeFilter = {
            'form.widget.integer' : 'integer',
            'form.widget.float'   : 'float',
            'form.widget.date'    : 'date',
            'form.widget.time'    : 'time'
        };

        /**
         * helper vars
         */
        var $field, elementType;


        /**
         * datatype filter
         * (default set)
         *
         * @type {*}
         */
        var filter = {
            /**
             * character filter
             *
             * @param $field
             * @param fn
             */
            '_chars' : function ($field, fn) {
                $field.keypress(function (event) {
                    var key = event.which || event.charCode;

                    // avoid ctrl+v end shift+insert
                    // TODO filter the content if it is parsed is nicer than completely forbid it
                    if ((event.ctrlKey === true && key === 118) ||
                        (event.shiftKey === true && event.keyCode === 45)) {
                        //return false; --> filter
                    }

                    if (event.altKey || event.ctrlKey) {
                        return true;
                    }
                    // Special filters will be assigned as callback.
                    if (typeof(fn) !== 'function') {
                        fn = function () {
                            return true;
                        };
                    }

                    return key !== 13 && (fn(key) || key === 0 || key === 8);
                });
            },


            /**
             * integer filter
             *
             * @param $field
             */
            '_integer' : function ($field) {
                filter._chars($field, function (key) {
                    switch (true) {
                        case key === 45: // Minus sign
                        case key >= 48 && key <= 57: // Integers
                            return true;

                        default:
                            return false;
                    }
                });
            },


            /**
             * date filter
             *
             * @param $field
             */
            '_date' : function ($field) {
                filter._chars($field, function (key) {
                    switch (true) {
                        case key >= 48 && key <= 57: // Integers
                            return true;

                        case key === new dateSeparator(pool.dateFormat).getKeyCode(): // Date separator
                            if ($field.val().replace(/\w+/g, '').length <= 1) {
                                return true;
                            }
                            return false;

                        default:
                            return false;
                    }
                });
            },


            /**
             * time filter
             *
             * @param $field
             */
            '_time' : function ($field) {
                // add autocomplete event
                $field.change(function () {
                    var value = $field.attr('value');
                    if (value.indexOf(':') === -1) {
                        switch (true) {
                            case value.length === 1:
                                $field.attr('value', '0' + value + ':00');
                                break;
                            case value.length === 2:
                                $field.attr('value', value + ':00');
                                break;
                            case value.length === 3:
                                // specification wants error here -> ask why!
                                // $field.attr('value', value[0] + value[1] + ':' + value[2] + 0);
                                break;
                            case value.length === 4:
                                $field.attr('value', value[0] + value[1] + ':' + value[2] + value[3]);
                                break;
                        }
                    }
                });

                filter._chars($field, function (key) {
                    var COLON = ':';

                    switch (true) {
                        case key >= 48 && key <= 57: // Integers
                            return true;

                        case key === COLON.charCodeAt(0): // Time separator
                            return ($field.val().indexOf(COLON) === -1);

                        default:
                            return false;
                    }
                });
            },


            /**
             * float filter
             *
             * @param $field
             */
            '_float' : function ($field) {
                filter._chars($field, function (key) {
                    switch (true) {
                        case key === 45: // Minus sign
                        case key >= 48 && key <= 57: // Integers
                            return true;

                        case key === pool.floatFormat.charCodeAt(0): // Decimal separator (one occurrence)
                            return ($field.val().indexOf(pool.floatFormat) === -1);

                        default:
                            return false;
                    }
                });
            }
        };


        /**
         * addelementTypeFilter
         *
         * @param name
         * @param call
         * @returns {jQuery}
         */
        this.addelementTypeFilter = function(name, call) {
            elementTypeFilter[name] = call;

            return this;
        };


        /**
         * add datatype filter
         *
         * @param name
         * @param fn
         * @returns {jQuery}
         */
        this.addFilter = function(name, fn) {
            filter['_' + name] = fn;

            return this;
        };


        // fallback for old calls
        this.filterChars   = filter._chars;
        this.filterInteger = filter._integer;
        this.filterDate    = filter._date;
        this.filterTime    = filter._time;
        this.filterFloat   = filter._float;


        // iterate over all input fields and filter datatypes
        $inputFields.each(function() {
            $field      = $(this);
            elementType = $field.data('element-type');

            // check element type
            if (elementType !== undefined) {
                // if filter for element is defined
                if (elementTypeFilter.hasOwnProperty(elementType) === true) {
                    filter['_' + elementTypeFilter[elementType]]($field);
                } else {
                    filter._chars($field);
                }
            } else { // else fallback for old calls
                switch (true) {
                    case $field.hasClass('integer'): filter._integer($field); break;
                    case $field.hasClass('float'):   filter._float($field);   break;
                    case $field.hasClass('date'):    filter._date($field);    break;
                    case $field.hasClass('time'):    filter._time($field);    break;
                    default:                         filter._chars($field);   break;
                }
            }
        });

        return $inputFields;
    };

}) (jQuery);

/**
 * Alcedis Event Handler
 *
 */
var alcedisEventHandler = {};

alcedisEventHandler.instance = (function () {
    var handler = {
        /**
         * DEVELOPER HELPER
         * If set to "true", the dev will see the events to hook
         */
        timerHelper: false,


        /**
         * main form object
         */
        registry: [],


        /**
         * isDialog
         *
         * @type    boolean
         */
        isDialog: false,


        /**
         * event param
         *
         * @type    object
         */
        param: null,


        /**
         * events collection
         */
        events: [],


        /**
         * params collection
         */
        params: {},


        /**
         * creates a new registry entry for event Handler
         *
         * @param   registryName
         * @param   entry
         * @return  void
         */
        setRegister: function (registryName, entry) {
            if (handler.registry[registryName] === undefined) {
                handler.registry[registryName] = [];
            }

            handler.registry[registryName].push(entry);
        },


        getRegister: function (registryName, selector) {
            var register = false;

            if (handler.registry[registryName] === undefined) {
                console.warn('no registry entry set');

                return false;
            } else {
                for (var i in handler.registry[registryName]) {
                    if (handler.registry[registryName][i].name === selector) {
                        register = handler.registry[registryName][i];
                    }
                }
            }

            return register;
        },


        /**
         * build event with dialog or form selection and fires event
         *
         * @param   e
         * @param   param
         * @return  void
         */
        event: function (e, param) {
            if (typeof e === 'object') {
                $.each(e, function (key, event){
                   handler.event(event, param);
                });
            } else {
                handler.fire(e, param);
            }
        },


        /**
         * directly fires the event
         *
         * @param   e
         * @param   param
         * @return  void
         */
        fire: function (e, param) {
            handler.setParam(e, param);

            if (typeof e === 'object') {
                $.each(e, function (key, event){
                   handler.fire(event, param);
                });
            } else {
                if (handler.timerHelper === true) {
                    console.warn(e);
                    console.log(param);
                }

                if (handler.events.length !== 0) {
                    handler.fireEvents(e, param);
                }
            }
        },


        /**
         * searches trough event stack and fires if event found
         *
         * @param   eventName
         * @param   param
         */
        fireEvents: function (eventName, param) {
            $.each(handler.events, function () {
                if (this[eventName] !== undefined) {
                    var status = this[eventName].call(handler, param);

                    if (status === 'once') {
                        delete this[eventName];
                    }

                    // Callback break -> dangerous: this will cause all following events of this type to be ignored
                    // use only false in events if you're really sure about what you want to do!!!!
                    if (status === false) {
                        return false;
                    }
                }
            });
        },


        /**
         * Add events to the event stack
         *
         * @param   eventObject
         * @return  void
         */
        addEvents: function (eventObject) {
            handler.events.push(eventObject);
        },


        /**
         * returns the form of the actual location
         * e.g dialog = dialogForm / main = mainform
         *
         * @return  alcedisForm
         */
        getForm: function (){
            var form = handler.isDialog === true ? handler.childrenForm : handler.alcedisForm;

            return form;
        },


        /**
         * returns the options of the actual form
         *
         * @return  object
         */
        getOptions: function () {
            var $form = handler.getForm();

            return $form.getOptions();
        },


        /**
         * returns the given param of an event if exist
         *
         * @param    e
         * @return   object
         */
        getParam: function (e){
            return handler.params[e];
        },


        setParam: function (e, param) {
            handler.params[e] = param;

            return false;
        },


        /**
         * set the children object of the handler
         *
         * @param   children
         * @return  void
         */
        setChildren: function (children) {
            handler.childrenForm = children;
        }
    };

    return handler;
}) ();


/**
 * poslist fieldtype extension skeleton
 * gets overwritten in jquery.poslist.js if loaded
 *
 * @copyright   Alcedis GmbH
 */
var alcedisPosListExtension = (function () {
    this.addType = function (type, callback) {};
    return self;
})();
